import { useGSAP } from "@gsap/react"
import clsx from "clsx"
import gsap from "gsap"
import { useRef } from "react"
import { ASSET_PREFIX } from "@/constants/routes"

export default function Underline({ className = "", isHover = false, isActive = false, size = "small", fullWidth = false, scale=1, transformOrigin = 'center center' }) {
  const root = useRef(null)

  useGSAP(() => {
    if (!root.current) return

    // When active, always show. When not active, show only on hover
    const shouldShow = isActive || (!isActive && isHover)
    const mm = gsap.matchMedia();

    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(root.current, {
        clipPath: shouldShow ? "inset(0% 0% 0% 0%)" : "inset(0% 100% 0% 0%)"
      })
    });

    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.to(root.current, {
        clipPath: shouldShow ? "inset(0% 0% 0% 0%)" : "inset(0% 100% 0% 0%)",
        duration: 0.6,
        ease: "expo.out"
      })
    });

    return () => mm.revert();
  }, [isHover, isActive])

  if (size === 'small') {
    return (
      <div
        ref={root}
        className={clsx(className, 'w-22 lg:w-[3.6875rem] h-auto')}
        style={{ clipPath: "inset(0% 100% 0% 0%)", transformOrigin, transform: `scaleX(${scale})` }}
      >
        <img className="w-full h-auto" src={`${ASSET_PREFIX}/img/svg/underline-small.svg`} alt="underline" width="59" height="6" />
      </div>
    )
  }

  if (size === 'medium') {
    return (
      <div
        ref={root}
        className={clsx(className, 'w-40 lg:w-27 h-auto')}
        style={{ clipPath: "inset(0% 100% 0% 0%)", transformOrigin, transform: `scaleX(${scale})` }}
      >
        <img className="w-full h-auto" src={`${ASSET_PREFIX}/img/svg/underline-medium.svg`} alt="underline" width="108" height="6" />
      </div>
    )
  }

  if (size === 'large') {
    return (
      <div
        ref={root}
        className={clsx(className, 'w-[8.3125rem] h-auto')}
        style={{ clipPath: "inset(0% 100% 0% 0%)", transformOrigin, transform: `scaleX(${scale})` }}
      >
        <img className="w-full h-auto" src={`${ASSET_PREFIX}/img/svg/underline-large.svg`} alt="underline" width="133" height="6" />
      </div>
    )
  }

  if (size === 'thin-large') {
    return (
      <div
        ref={root}
        className={clsx(className, fullWidth ? 'w-full' : 'w-[8.3125rem]', 'h-auto')}
        style={{ clipPath: "inset(0% 100% 0% 0%)", transformOrigin, transform: `translateZ(0) scaleX(${scale})` }}
      >
        <img className="w-full h-auto" src={`${ASSET_PREFIX}/img/svg/underline-thin-large.svg`} alt="underline" width="133" height="6" />
      </div>
    )
  }

  if (size === 'thin-medium') {
    return (
      <div
        ref={root}
        className={clsx(className, fullWidth ? 'w-full' : 'w-[8.3125rem]', 'h-auto')}
        style={{ clipPath: "inset(0% 100% 0% 0%)", transformOrigin, transform: `translateZ(0) scaleX(${scale})` }}
      >
        <img className="w-full h-auto" src={`${ASSET_PREFIX}/img/svg/underline-thin-medium.svg`} alt="underline" width="133" height="6" />
      </div>
    )
  }




}

